const authReducer = (previousState = 0, { type, payload }: any) => {
    if (type === 'AUTH_RECEIVED') {
        return payload.access_token;
    }
    return previousState;
}

export default authReducer;